import { useEffect } from 'react'

import { verifySession } from '../api/verifySession'
import { refreshToken } from '../api/refreshToken'
import { useAuth } from '../customHooks/useAuth'
import { useStorage } from '../customHooks/useStorage'
import { User } from '../api/signin'
import { CanBeAnything } from '../types'

const refreshTokenIntervalSeconds = process.env.REACT_APP_REFRESH_TOKEN_INTERVAL_IN_MS as string

export const RefreshHandler = () => {
  const { user, setUser, isAuthenticated } = useAuth()
  const { setValue: setUserSession, remove: removeUser } = useStorage('user', {}, 'session')

  //VERIFY SESSION ON FIRST RENDER
  useEffect(() => {
    const verifyTheSession = async () => {
      try {
        await verifySession(
          user?.email?.toLowerCase() || '',
          user?.tokens?.accessToken.token || '',
          user?.isSSO
        )
      } catch {
        removeUser()
        setUser(null)
      }
    }
    if (isAuthenticated && user?.tokens?.accessToken.token) verifyTheSession()
    else {
      removeUser()
      setUser(null)
    }
  }, [isAuthenticated, removeUser, setUser, user?.email, user?.isSSO, user?.tokens])

  useEffect(() => {
    // eslint-disable-next-line
    let refreshInterval: any

    const refreshTheToken = async () => {
      try {
        const refreshTokenResponse = await refreshToken(
          user?.email?.toLowerCase() || '',
          user?.tokens?.refreshToken || '',
          user?.isSSO || false
        )
        const tokens: CanBeAnything = refreshTokenResponse.data.data

        if (user) {
          const updatedUser: User = {
            ...user,
            tokens: {
              ...tokens,
              accessToken: {
                ...tokens.accessToken,
                token: tokens.accessToken.jwtToken,
              },
            },
            authenticated: true,
          }
          setUserSession(updatedUser)
          setUser(updatedUser)
        }
      } catch {
        removeUser()
        setUser(null)
      }
    }
    if (isAuthenticated) {
      refreshInterval = setInterval(refreshTheToken, Number(refreshTokenIntervalSeconds))
    }

    return () => {
      clearInterval(refreshInterval)
    }
  }, [isAuthenticated, removeUser, setUser, setUserSession, user])

  return null
}
